module.exports = __webpack_public_path__ + "static/abtest-7fe8897a983b0b501d03a72138c43f8a.png";